import { takeEvery, put } from 'redux-saga/effects'
import { push, replace } from 'connected-react-router'
import { handleExternalRedirectQuery } from 'store/entities/router/actions'
import { store } from 'store'
import { DASHBOARD, REDIRECT_PAGE } from 'app/domains/routes/constants'
export default function* externalRedirectSaga() {
  yield takeEvery(handleExternalRedirectQuery, handleExternalRedirectSaga)
}

export enum RedirectType {
  Cancel = 'cancel',
  RedirectToUrl = 'redirectToUrl',
  ClickOnLinkRedirect = 'clickOnLinkRedirect',
  ClickOnLinkRedirectSafariMobile = 'ClickOnLinkRedirectSafariMobile',
}

const openTabSafari = (url: string) => {
  // Safari Mobile is not opening the new tab
  // instead of this it opens new window in the current tab
  /**
   * https://discussions.apple.com/thread/8261700
   * https://stackoverflow.com/questions/4907843/open-a-url-in-a-new-tab-and-not-a-new-window
   * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
   */
  // Create link in memory
  const a = window.document.createElement('a')
  a.href = url

  // Dispatch  click
  const e = new MouseEvent('click', {
    clientX: 0,
    clientY: 0,
    screenX: 0,
    screenY: 0,
    bubbles: true,
    cancelable: true,
    view: window,
    detail: 0,
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
    button: 0,
    relatedTarget: null,
  })
  a.dispatchEvent(e)
}

export const runRedirect = (externalRedirectLink: string, internalRedirect: string, redirection: RedirectType) => {
  if (!externalRedirectLink.startsWith('https') && !externalRedirectLink.startsWith('http')) {
    // The browser will use whatever the current protocol is (http, https, etc.) but the // tells it that this is a new root address.
    // we need that condition in case when the url looks like that - google.com
    externalRedirectLink = '//' + externalRedirectLink
  }

  const openNewTab = () => {
    // if new tab wouldn't be open - window.open return null in this cas
    const newTab = window.open('', '_blank')
    if (newTab) {
      newTab.location.href = externalRedirectLink
    }
    return !!newTab
  }

  if (redirection === RedirectType.Cancel) {
    store.dispatch(replace(`/${DASHBOARD}`))
  } else if (redirection === RedirectType.RedirectToUrl && openNewTab()) {
    // if new tab will be opened we can replace current url to dashboard
    // if this is not a case: popUp blocker has been activated dashboard is not rendered
    store.dispatch(replace(internalRedirect || `/${DASHBOARD}`))
  } else if (redirection === RedirectType.ClickOnLinkRedirect && openNewTab()) {
    store.dispatch(replace(internalRedirect || `/${DASHBOARD}`))
  } else if (redirection === RedirectType.ClickOnLinkRedirectSafariMobile) {
    store.dispatch(replace(`/${DASHBOARD}`))
    openTabSafari(externalRedirectLink)
  }
}

export function* handleExternalRedirectSaga({ payload }) {
  // set payload to router state to get externalRedirectLink in RedirectPage component
  yield put(push({ pathname: `/${REDIRECT_PAGE}`, state: { externalRedirect: true, redirectQuery: payload } }))
}
